module.exports = __webpack_public_path__ + "img/7.ebb60ac6.png";